import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

import checkedCircle from "@/assets/check-circle.png";
import AuthPageShell from "../components/AuthPageShell";
import AuthPrimaryButton from "../components/AuthPrimaryButton";
import DownloadAgreement from "../components/DownloadAgreement";

const SuccessfulRegistrationPage = () => {
  const { t } = useTranslation("auth");
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate("/login");
  };

  return (
    <AuthPageShell title={t("success.registration.title")}>
      <div className="mb-6 flex flex-col items-center gap-3 text-center">
        <img src={checkedCircle} alt="success" className="h-12 w-12" />

        <p className="text-sm text-gray-500">
          {t("success.registration.approvalLine1")}
        </p>

        <p className="text-sm text-gray-500">
          {t("success.registration.approvalLine2")}
        </p>
      </div>

      <div className="mb-6">
        <DownloadAgreement />
      </div>

      <AuthPrimaryButton type="button" onClick={handleLoginClick}>
        {t("success.registration.goToLogin")}
      </AuthPrimaryButton>
    </AuthPageShell>
  );
};

export default SuccessfulRegistrationPage;
